import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Stack, Dialog, Typography, IconButton } from '@mui/material';

import useResponsive from 'src/hooks/useResponsive';

import InfoRow from './InfoRow';
import Iconify from '../../../components/iconify';

DepartmentDetails.propTypes = {
  setOpen: PropTypes.func,
  department: PropTypes.object,
  open: PropTypes.bool,
  tickets: PropTypes.number,
  users: PropTypes.number,
};

export default function DepartmentDetails({ setOpen, open, department, tickets, users }) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsive();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      anchor="right"
      open={open}
      onClose={handleClose}
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '80vh',
          overflowY: 'auto',
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: (theme) =>
            theme.palette.mode === 'dark'
              ? 'rgba(22, 27, 34, 0.9)'
              : 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
          '::-webkit-scrollbar': {
            width: '2px',
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(145, 158, 171, 0.4)',
            borderRadius: '10px',
          },
          '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(145, 158, 171, 0.6)',
          },
        },
      }}
    >
      <Stack direction="row" justifyContent="flex-end">
        <IconButton sx={{ cursor: 'pointer', mr: 1 }} onClick={handleClose}>
          <Iconify
            icon="eva:close-square-fill"
            width={isSmallScreen ? 25 : 30}
            sx={{
              color: (theme) => theme.palette.grey[500],
              transition: 'color 0.3s',
              '&:hover': {
                color: '#B72136',
              },
            }}
          />
        </IconButton>
      </Stack>
      <img
        src={department.image || '/assets/images/departments/defaultDepartment.png'}
        alt="Selected"
        style={{
          borderRadius: '10px',
          objectFit: 'cover',
          maxHeight: '180px',
          display: 'block',
          marginLeft: '18px',
          marginRight: '18px',
        }}
      />

      <Stack sx={{ px: 2, py: 3 }}>
        <Box
          bgcolor="background.neutral"
          borderRadius={3}
          sx={{ px: 2, py: 2, border: '1px solid', borderColor: 'divider' }}
        >
          <Stack spacing={2}>
            <InfoRow
              icon="fluent-emoji-high-contrast:department-store"
              label={`${t('attributes.name')} :`}
              value={department.name}
            />
            <InfoRow icon="tabler:id" label="ID :" value={department.id} />
            <InfoRow
              icon="hugeicons:manager"
              label={`${t('pages.departmentPage.details.numAgents')} :`}
              value={users}
            />
            <InfoRow
              icon="emojione-monotone:admission-tickets"
              label={`${t('pages.departmentPage.details.numTickets')} :`}
              value={tickets}
            />

            <Stack>
              <Box display="flex" alignItems="center">
                <Iconify
                  icon="fluent:text-description-16-filled"
                  sx={{ color: 'text.secondary', marginRight: '15px' }}
                />
                <Typography>{`${t('attributes.description')} :`}</Typography>
              </Box>
              <Box pl={4.5}>
                <Typography variant="body2">{department.description}</Typography>
              </Box>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Dialog>
  );
}
